import React from 'react';
import { useTranslation } from 'react-i18next';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { DeviationTypes } from '../../../../types/deviation';
import { getDeviationType } from '../../../_helpers';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import s from './ThumbLink.scss';
const ThumbLink = ({ deviation, width, height, children, wrapperClassName })=>{
    const { t } = useTranslation();
    const a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
    const linkAsWrapper = getDeviationType(deviation) === DeviationTypes.IMAGE;
    if (linkAsWrapper) {
        return /*#__PURE__*/ React.createElement(DeviationLink, {
            "aria-label": a11yLabel,
            deviation: deviation,
            className: wrapperClassName,
            style: {
                width,
                height
            }
        }, children);
    }
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            width,
            height
        },
        className: wrapperClassName
    }, children, /*#__PURE__*/ React.createElement(DeviationLink, {
        deviation: deviation,
        className: s['link-overlay'],
        title: deviation.title,
        "aria-label": a11yLabel
    }, /*#__PURE__*/ React.createElement("span", null)));
};
ThumbLink.displayName = 'ThumbLink';
export default ThumbLink;
